<template>
    <div class="alert alert-info holidays-alert">
        <div class="holidays-alert__edit-delete-panel" v-if="editable">
            <i class="fa fa-pencil color-dark-blue pointer" @click="onEdit"></i>
            <i class="fa fa-trash-o color-red pointer" @click="onDelete"></i>
        </div>
        <strong>Holiday!</strong>
        <div class="">
            Repeated Events in this Group are canceled due to the <strong v-if="holiday.name">{{holiday.name}}</strong>
            Holiday
            between <strong>{{this.holiday.start}}</strong> and
            <strong>{{this.holiday.end}}</strong>.
        </div>
        <div class="">
            <i>
                {{holiday.description}}
            </i>
        </div>
        <div class="holidays-alert__created-label">
            Created by
            <simple-link :target="holiday.created_by"></simple-link>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import {URL_DATE_FORMAT, VISUAL_DATE_FORMAT} from "../../events/new_calendar/config";

    export default {
        props: {
            holiday: Object,
            editable: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
        },
        name: "GroupEventsHoliday",
        methods: {
            onEdit() {
                this.$emit('onEdit');
            },
            onDelete() {
                this.$emit('onDelete');
            },
        }
    };
</script>

<style scoped lang="scss">
    .holidays-alert {
        position: relative;
        padding-bottom: 25px;

        &__created-label {
            font-size: 10px;
            position: absolute;
            right: 5px;
            bottom: 5px;
        }

        &__edit-delete-panel {
            position: absolute;

            right: 5px;
            top: 5px;
            font-size: 21px;
        }
    }
</style>